import React, { useRef, useState } from 'react'
import { history } from '../../utils/variables';
import Modal from '../../components/master/Modal';
import Plate from '../../components/expert/Plate';
import Input from '../../components/master/Input';
import { ConvertToEnglish, pexios, toast, UserLabel, validate } from '../../utils/functions';
import { useDispatch, useSelector } from 'react-redux';
import { setAccidentInfo } from '../../redux/actions';
import Loading from '../../assets/images/gifs/loading.gif'
import HeaderIcon from '../../assets/images/header-icon/car-query.png'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

export const Plans = () => {
    const {accidentInfo,routerData} = useSelector(store => store);
    const location = useLocation();
    const uniqeItems = location.state;
    const userType = accidentInfo.user_type;
    const [loader ,setLoader] =useState(false)
    const form = useRef()
    const [focusFeild,setFocusFeild] = useState(false)
    const [searchType,setSearchType] = useState('pelak')
    const dispatch = useDispatch()
    
    
    const [data,setData] = useState({
        nationalId : '',
        plate_type: 'car',
        plate_iran: '',
        plate_left: '',
        plate_center: '',
        plate_right: '',
        chassis_number: '',
        motor_number: ''
    })
    
    function checkRepeated () {
        let foundItem = []
        switch (searchType) {
            case 'pelak' :
                foundItem = uniqeItems?.filter(item=>(
                    item.plate_type === data.plate_type &&
                    ConvertToEnglish(item.plate_iran ) ===  ConvertToEnglish(data.plate_iran )&& 
                    ConvertToEnglish(item.plate_left ) ===  ConvertToEnglish(data.plate_left )&& 
                    ConvertToEnglish(item.plate_right) ===  ConvertToEnglish(data.plate_right)&& 
                    item.plate_center === data.plate_center
                ))
                return foundItem?.length
            default:
                foundItem = uniqeItems?.filter(item=>ConvertToEnglish(item.chassis_number.toLowerCase()) === ConvertToEnglish(data.chassis_number.toLowerCase()))
                return foundItem?.length
        }
    }
    
    function changeData(value, name) {
        setData(prevState => ({
            ...prevState,
            [name]: value.trim(),
        }));
    }
    // function search() {
    //     const error = validate(form);
    //     if (error) {
    //         toast(`فیلد های اجباری ${error} را پر کنید.`, 'error');
    //         return;
    //     }
    //     setLoader(false);
    //     // pexios(`api/save_user_car_info`, 'post', data)
    //     //     .then(() => {
    //             history.push(`/user-car-info?user=${userType}`);
    //         // });
    // }
    function changeSearchType(type){
        setSearchType(type)
        setFocusFeild(false)
        setData({
            nationalId : '',
            plate_type: 'car',
            plate_iran: '',
            plate_left: '',
            plate_center: '',
            plate_right: '',
            chassis_number: '',
            motor_number: ''
        })
    }
    function searchHandle(){
        const error = validate(form);
        if (error) {
            toast(`فیلد های اجباری ${error} را پر کنید.`, 'error');
            return;
        }
        const repeatedError = accidentInfo.user_type === 'losses' && checkRepeated();
        if(repeatedError) {
            if(searchType === 'pelak') {
                toast(`شماره پلاک تکراری میباشد`, 'error');
                return;
            }else {
                toast(`شماره شاسی تکراری میباشد`, 'error');
                return;
            }
        }
        // if(searchType === 'sanhub' && data.nationalId.length !== 10){
        //     toast('کد ملی نامعتبر است', 'error');
        //     return;
        // }
        // if(searchType === 'sanhub' && (data.plate_left.length !== 2 || data.plate_iran.length !== 2 || data.plate_right.length !== 3)){
        //     toast('شماره پلاک نامعتبر است', 'error');
        //     return;
        // }
        // if(searchType === 'sanhub'){
        //     const carData = {
        //         n_code : data.nationalId,
        //         plate_type: data.plate_type,
        //         plate_iran: data.plate_iran,
        //         plate_left: data.plate_left,
        //         plate_center: data.plate_center,
        //         plate_right: data.plate_right,
        //     }
        //     search(searchType,carData)
        // }
        // else {
        //     search(searchType,{chassis_number:data.chassis_number})
        // }
        switch (searchType) {
            // case 'sanhub':
            //     const carData = {
            //         n_code : data.nationalId,
            //         plate_type: data.plate_type,
            //         plate_iran: data.plate_iran,
            //         plate_left: data.plate_left,
            //         plate_center: data.plate_center,
            //         plate_right: data.plate_right,
            //     }
            //     setLoader(true);
            //     pexios('api/check_sanhub_car','post',{...carData,for: userType === 'culprit' ? 'culprit':'loss'})
            //     .then(res=>{
            //         const response = res.data
            //         if(response.status === 'ok'){
            //             setData({...data,...response.car,title: response.res})
            //             setLoader(false);
            //         }else{
            //             setLoader(false);
            //             toast(response.massage, 'error');
            //             return;
            //         }
            //     })
            //     break;
            case 'chassis' :
                setLoader(true);
                pexios(`api/check_chassis`, 'post', {chassis_number:data.chassis_number})
                .then((res)=>{
                    const response = res.data
                    if (response.found === true){
                        dispatch(setAccidentInfo({...accidentInfo,details:response.car,searchType:'chassis'}))
                    }
                    else{
                        dispatch(setAccidentInfo({...accidentInfo,details:{chassis_number:data.chassis_number,id:response.car.id},searchType:'chassis'}))
                    }
                    setLoader(false);
                    routerData.type === 'register' ?
                    history.push('/register-data')
                    :
                    history.push('/user-info')
                })
                .catch(()=>{
                    toast('این استعلام هم اکنون دردسترس نیست . از روش دیگری استفاده نمایید','error')
                    setLoader(false)
                })
                break;
            case 'pelak' :
                const pelakPayload = {
                    plate_type: data.plate_type,
                    plate_iran: data.plate_iran,
                    plate_left: data.plate_left,
                    plate_center: data.plate_center,
                    plate_right: data.plate_right,
                    flag :'pelak',
                    type: accidentInfo.insurance_type === 'body' ? 'both' : 'third'
                }
                setLoader(true)
                pexios('api/check_api_car','post',pelakPayload)
                .then((res)=>{
                    const response = res.data
                    if (response.status === 'ok'){
                        dispatch(setAccidentInfo({...accidentInfo,details:response.car,searchType:'pelak'}))
                        routerData.type === 'register' ?
                        history.push('/register-data')
                        :
                        history.push('/user-info')
                    }
                    else{
                        setLoader(false);
                        toast(response.massage, 'error');
                        return;
                    }
                })
                .catch((err)=>{
                    toast('این استعلام هم اکنون دردسترس نیست . از روش دیگری استفاده نمایید','error')
                    setLoader(false)
                })
                break;
            case 'motor&chassis' :
                const motorPayload = {
                    chassis_number: data.chassis_number,
                    motor_number: data.motor_number,
                    flag :'chassis',
                    type: accidentInfo.insurance_type === 'body' ? 'both' : 'third'
                }
                setLoader(true)
                pexios('api/check_api_car','post',motorPayload)
                .then((res)=>{
                    const response = res.data
                    if (response.status === 'ok'){
                        dispatch(setAccidentInfo({...accidentInfo,details:response.car,searchType:'motor&chassis'}))
                        routerData.type === 'register' ?
                        history.push('/register-data')
                        :
                        history.push('/user-info')
                    }
                    else{
                        setLoader(false);
                        toast(response.massage, 'error');
                        return;                    
                    }
                })
                .catch(()=>{
                    toast('این استعلام هم اکنون دردسترس نیست . از روش دیگری استفاده نمایید','error')
                    setLoader(false)
                })
                break;
            default: break;

        }
    }
  return (
    <div className='content'> 
        <Modal visible={loader}>
            <div className='loader-modal'>
                {/* <i className='fas fa-spinner fa-spin'/> */}
                <img src={Loading} alt="loader"/>
            </div>
        </Modal>

        <>
            <div className='search-information'>
                <div className='title-image'>
                    <img src={HeaderIcon} alt="icon"/>
                </div>
                <p className='title-text mt20'>در این قسمت شما می توانید با استفاده از یکی از روش های زیر اقدام به <span style={{fontWeight:600}}>استعلام خودرو {accidentInfo.insurance_type === 'third' && UserLabel(userType)}</span> نمایید.</p>
                <div className='btn-groups mt20'>
                    <button className={`btn btn-block ${searchType === 'chassis' ? 'active' :''}`} onClick={()=>changeSearchType('chassis')}>شماره شاسی</button>
                    <button className={`btn btn-block ${searchType === 'motor&chassis' ? 'active' :''}`} onClick={()=>changeSearchType('motor&chassis')}>شاسی و موتور</button>
                    <button className={`btn btn-block ${searchType === 'pelak' ? 'active' :''}`} onClick={()=>changeSearchType('pelak')}>پلاک</button>
                    {/* <button className={`btn btn-block btn-circle-right ${searchType === 'sanhub' ? 'active' :''}`} onClick={()=>changeSearchType('sanhub')}>شماره پلاک</button> */}
                </div>
                    {/* { searchType === 'sanhub' &&
                    <div className='search-box' ref={form}>
                    <Plate
                        type={data.plate_type}
                        plate={{
                            plate_iran: data.plate_iran,
                            plate_left: data.plate_left,
                            plate_center: data.plate_center,
                            plate_right: data.plate_right,
                        }}
                        change={(value, name) => changeData(value, name)}
                        disableType={true}
                        required
                        changeFeild={(val)=>setFocusFeild(val)}
                    />
                    <Input 
                        label='کد ملی'
                        required
                        value={data.nationalId}
                        onChange={value => changeData(value, 'nationalId')}
                        col={12}
                        maxLength={10}
                        name='nationalId'
                        focus={focusFeild}
                        isLTR
                        mode='numeric'
                        />
                    </div>
                    } */}
                    { searchType === 'pelak' &&
                    <div className='search-box' ref={form}>
                    <Plate
                        type={data.plate_type}
                        plate={{
                            plate_iran: data.plate_iran,
                            plate_left: data.plate_left,
                            plate_center: data.plate_center,
                            plate_right: data.plate_right,
                        }}
                        change={(value, name) => changeData(value, name)}
                        disableType={true}
                        required
                        changeFeild={(val)=>setFocusFeild(val)}
                        col={12}
                    />
                    </div>
                    }
                    {searchType === 'motor&chassis' && 
                        <div className='search-box' ref={form}>
                        <Input
                            // col={12}
                            label='شماره شاسی'
                            value={data.chassis_number}
                            onChange={value => changeData(value, 'chassis_number')}
                            placeholder={' '}
                            required
                            focus={searchType === 'motor&chassis'}
                        />
                        <Input
                            // col={12}
                            label='شماره موتور'
                            value={data.motor_number}
                            onChange={value => changeData(value, 'motor_number')}
                            placeholder={' '}
                            required
                        />
                        </div>
                    }
                    {searchType === 'chassis' && 
                        <div className='search-box' ref={form}>
                        <Input
                            col={12}
                            label='شماره شاسی'
                            value={data.chassis_number}
                            onChange={value => changeData(value, 'chassis_number')}
                            placeholder={' '}
                            required
                            focus={searchType === 'chassis'}
                        />
                        </div>
                    }
                <div className='d-flex justify-center mt20'>
                    <button className={`btn btn-circle w-50 ${!loader ? 'btn-white-purple btn-bold' :'btn-disable'}`} onClick={searchHandle}>ادامه</button>
                </div>
                
                </div>
                </>
    </div>
  )
}
